import React, { useEffect, useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import ContestService from "../services/ContestService";
import IssueNumberService from "../services/IssueNumberService";
import { MdEdit } from "react-icons/md";

const ContestBatchMaster = ({ isLoggedIn }) => {
  const issueNumberService = new IssueNumberService();
  const surveyLink = useRef(null);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [sortVal, setsortVal] = useState(-1);
  const contestService = new ContestService();
  const [tableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: ""
  });
  const [triggerDownload, setTriggerDownload] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState({
    id: 0,
    productId: "",
    batchNumber: "",
    CreatedBy: "",
    IsActive: true
  });

  const [formErrors, setFormErrors] = useState({
    productId: "",
    batchNumber: ""
  });

  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
      Promise.all([fetchBatchData(), GetProducts()])
        .then(() => {
          // All data fetching and operations have completed
          setLoading(false); // Data has loaded, set loading to false
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false); // Set loading to false in case of an error
        });
    } else {
      isLoggedIn(false); // User is not logged in
      navigate("/login"); // Redirect to the login page
    }
  }, [isLoggedIn, navigate, setFormData]);

  useEffect(() => {
    if (triggerDownload) {
      surveyLink.current.link.click();
      setTriggerDownload(false); // Reset the trigger after download
    }
  }, [triggerDownload]);

  function fetchBatchData() {
    setLoading(true);
    contestService
      .GetContestBatchDetails(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales
          }));
          setLoading(false);
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: []
          }));
          setLoading(false);
        }
      })
      .catch((error) => {
        // console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setLoading(false);
      });
  }

  const searchFilter = (e) => {
    const value = e.target.value;
    setLoading(false);
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchBatchData();
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: event.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchBatchData();
  };

  const onPage = (event) => {
    setLoading(true);
    getLazyLoadingValues(event);
    fetchBatchData();
  };

  const handleDialogOpen = async () => {
    setIsEdit(false);
    setOpenDialog(true);
  };

  const editDialogOpen = (row) => {
    const editMode = () => {
      setIsEdit(true);
      setFormData((prevData) => ({
        ...prevData,
        id: row.id,
        productId: row.productId,
        batchNumber: row.batchNumber,
        IsActive: row.isActive
      }));
      setOpenDialog(true); // Add action
    };
    return (
      <Button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2
              rounded text-sm hover:bg-blue-700 hover:text-white cursor-pointer"
        onClick={editMode}
      >
        <MdEdit />
      </Button>
    );
  };

  const initialFormData = {
    id: 0,
    productId: "",
    batchNumber: "",
    IsActive: true
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setFormData(initialFormData);
    setFormErrors({
      productId: "",
      batchNumber: ""
    });
  };

  const validateForm = (name, value) => {
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "productId":
        if (value.length < 1) {
          IsValid = false;
          errors.productId = "Please select product name.";
        } else errors.productId = "";
        break;
      case "batchNumber":
        if (value.length < 1) {
          IsValid = false;
          errors.batchNumber = "Please enter batch number.";
        } else {
          errors.batchNumber = "";
        }
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  const handleFormChange = (event) => {
    const { name, value, checked, type } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type == "checkbox" ? checked : value
    }));
    if (name === "productId") {
      handleProductChange(value);
    }
    validateForm(name, value);
    console.log(formData);
  };

  function GetProducts() {
    issueNumberService
      .getproducts(0)
      .then((response) => {
        const data = response.responseData;
        setProducts(data);
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }

  const handleProductChange = (value) => {
    const selectedProductId = value;

    setFormData((prevFormData) => ({
      ...prevFormData,
      productId: selectedProductId
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = formData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });
    if (isfrmvalid) {
      try {
        formData.CreatedBy = sessionStorage.getItem("userId");
        contestService
          .AddContestBatchDetails(formData)
          .then((response) => {
            const data = response;
            setLoading(false);
            if (data.responseCode == "200") {
              setFormData((prevFormData) => ({
                ...prevFormData,
                id: 0,
                productId: "",
                batchNumber: "",
                IsActive: true
              }));
              handleDialogClose();
              fetchBatchData();
              toast.success(data.responseMessage);
            } else {
              toast.error(data.responseMessage);
            }
          })
          .catch((error) => {
            // console.error("API request failed:", error);
            toast.error("Failed to fetch data");
            setLoading(false);
          });
      } catch (error) {
        console.error("Error creating issue data:", error);
      }
    }
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Contest Batch Master
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        {
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="button"
            variant="contained"
            onClick={handleDialogOpen}
          >
            (+) Add Batch Details
          </button>
        }
      </div>
    </div>
  );
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <div className="mt-3">
              <div className="container-fluid mt-3 mb-3">
                <DataTable
                  exportFilename="DeMapping Report"
                  responsive={true}
                  header={header}
                  globalFilter={state.globalFilter}
                  emptyMessage={state.emptyMessage}
                  value={state.sales}
                  paginator={true}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={state.rows}
                  rowsPerPageOptions={[10, 50, 200, 500]}
                  totalRecords={state.totalRecords}
                  lazy={true}
                  first={state.first}
                  onPage={onPage}
                  onSort={(e) => {
                    e.sortOrder = -sortVal;
                    setsortVal(-sortVal);
                    onSort(e);
                  }}
                  className="p-datatable-responsive"
                >
                  <Column
                    field="productName"
                    header="SKU Name"
                    sortable={true}
                  />
                  <Column
                    field="batchNumber"
                    header="Batch Number"
                    sortable={true}
                  />
                  <Column
                    body={editDialogOpen}
                    header="Action"
                    style={{ width: "250px" }}
                  />
                </DataTable>
              </div>
            </div>

            <Dialog
              open={openDialog}
              onClose={handleDialogClose}
              className="add"
              fullWidth
            >
              <div className="modal-header">
                <h5 className="modal-title adduser">
                  Add Contest Batch Details
                </h5>
              </div>

              <form onSubmit={handleSubmit}>
                <DialogContent>
                  <InputLabel id="productDropdown">Product SKU</InputLabel>
                  <Select
                    fullWidth
                    disabled={isEdit}
                    labelId="productDropdown"
                    value={formData.productId}
                    name="productId"
                    onChange={handleFormChange}
                  >
                    {products &&
                      products.map((product) => (
                        <MenuItem key={product.id} value={product.id}>
                          {product.label}
                        </MenuItem>
                      ))}
                  </Select>
                  {!!formErrors.productId && (
                    <FormHelperText>
                      <span className="text-red-500">
                        {formErrors.productId}
                      </span>
                    </FormHelperText>
                  )}
                  <TextField
                    disabled={isEdit}
                    margin="dense"
                    label="Batch Number"
                    type="text"
                    name="batchNumber"
                    value={formData.batchNumber}
                    onChange={handleFormChange}
                    fullWidth
                    error={!!formErrors.batchNumber}
                    helperText={formErrors.batchNumber}
                  />
                  <label className="mt-3">
                    <input
                      type="checkbox"
                      name="IsActive"
                      checked={formData.IsActive}
                      onClick={handleFormChange}
                    />
                    Active
                  </label>

                  <div className="row justify-content-center">
                    <div className="col-md-6">
                      <DialogActions>
                        <Button
                          onClick={handleDialogClose}
                          className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                          type="button"
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          color="primary"
                          className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                          Submit
                        </Button>
                      </DialogActions>
                    </div>
                  </div>
                </DialogContent>
              </form>
            </Dialog>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContestBatchMaster;
